import { forwardRef } from "react";
import { styled } from "goober";

const Container = styled("div", forwardRef)`
  container-type: inline-size;
  container-name: content-container;
  width: 100%;
  max-width: var(--sp-container);
  margin: 0 auto;
`;

export default Container;
